import { ProductSlider } from "@repo/components";
import { getUserSessionServer } from "@repo/lib/utils";
import { getPromotionProducts } from "@repo/server-actions/homepage";
import { getWishlist } from "@repo/server-actions/wishlist";
const PromotionsProducts = async ({
  data,
  locale
}) => {
  const {
    title,
    PromotionItem
  } = data;
  const transformedSku = {
    skus: PromotionItem?.map(item => item.sku) || []
  };
  if (transformedSku.skus.length === 0) return; // Do not render the component if no skus are entered in the admin for this component
  const sessionPromise = await getUserSessionServer();
  const productsPromise = await getPromotionProducts(transformedSku, locale);
  const session = await sessionPromise;
  const wishlistPromise = await getWishlist(locale);
  const [wishlist, products] = await Promise.all([wishlistPromise, productsPromise]);
  if (!products.length) return; // Do not render the component if the entered sku from strapi is not found in the catalog

  return <section className="mx-auto px-4 md:max-w-screen-xl md:px-0" data-sentry-component="PromotionsProducts" data-sentry-source-file="PromotionsProducts.jsx">
      <ProductSlider title={title} items={products} type={title} wishlistItems={wishlist?.content} data-sentry-element="ProductSlider" data-sentry-source-file="PromotionsProducts.jsx" />
    </section>;
};
export default PromotionsProducts;